// eslint-disable-next-line
import axios from "axios";
import {
  scopedFindingRuleAPI,
  params,
  header,
  anomalyRuleAPI,
  machineHMIAPI,
  machineNodeAPI,
  machineFunctionAPI,
} from "../_api";
import {
  SCOPED_FINDING_RULE_REQUEST,
  FETCH_SCOPED_FINDING_RULE_SUCCESS,
  FETCH_SCOPED_FINDING_RULE_FAILURE,
  UPDATE_SCOPED_FINDING_RULE_SUCCESS,
  UPDATE_SCOPED_FINDING_RULE_FAILURE,
  CREATE_NEW_SCOPED_FINDING_SUCCESS,
  CREATE_NEW_SCOPED_FINDING_FAILURE,
  FETCH_HMI_SUCCESS,
  FETCH_NODE_SUCCESS,
  FETCH_NODE_FAILURE,
  FETCH_FUNCTION_SUCCESS,
  FETCH_FUNCTION_FAILURE,
  FETCH_HMI_FAILURE,
  SET_LOADING,
} from "../_constants";

//scoped finding rule
const fetchScopedFindingRuleRequest = () => {
  return { type: SCOPED_FINDING_RULE_REQUEST };
};

const fetchScopedFindingRuleSuccess = (data) => {
  return { type: FETCH_SCOPED_FINDING_RULE_SUCCESS, payload: data };
};

const fetchScopedFindingRuleFailure = (error) => {
  return { type: FETCH_SCOPED_FINDING_RULE_FAILURE, payload: error };
};

//scoped finding rule
export const fetchScopedFindingRule = (queryParams,machine_type,hmi_type) => {
  return async (dispatch) => {
    dispatch(fetchScopedFindingRuleRequest());
    return axios
      .get(scopedFindingRuleAPI, {
        params: {
          ...params,
          machine_type:machine_type,
          hmi_type:hmi_type,
          ...queryParams,
          userid: sessionStorage.getItem('userId')
        },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchScopedFindingRuleSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchScopedFindingRuleFailure(errorMsg));
      });
  };
};

const updateScopedFindingRuleSuccess = (data) => {
  return { type: UPDATE_SCOPED_FINDING_RULE_SUCCESS };
};

const updateScopedFindingRuleFailure = (error) => {
  return { type: UPDATE_SCOPED_FINDING_RULE_FAILURE, payload: error };
};

export const updateScopedFindingRule = (rule,machine_type,hmi_type,handleError=()=>{}) => {
  return async (dispatch) => {
    return axios({
      method: "put",
      url: scopedFindingRuleAPI,
      params: {
        ...params,
        machine_type:machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: rule,
    })
      .then((response) => {
        dispatch(updateScopedFindingRuleSuccess(response.data));
        handleError(true)
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(updateScopedFindingRuleFailure(errorMsg));
        handleError(false)
      });
  };
};

const createNewScopedFindingSuccess = (data) => {
  return { type: CREATE_NEW_SCOPED_FINDING_SUCCESS, payload: data };
};

const createNewScopedFindingFailure = (error) => {
  return { type: CREATE_NEW_SCOPED_FINDING_FAILURE, payload: error };
};

export const createNewScopedFinding = (body, machine_type,hmi_type, handleCreateScopedFindingRule) => {
  return async (dispatch) => {
    return axios({
      method: "POST",
      url: scopedFindingRuleAPI,
      params: {
        ...params,
        machine_type: machine_type,
        hmi_type:hmi_type,
        userid: sessionStorage.getItem('userId')
      },
      headers: header,
      data: body,
    })
      .then((response) => {
        dispatch(createNewScopedFindingSuccess(response.data));
        handleCreateScopedFindingRule(true);
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        handleCreateScopedFindingRule(false);
        dispatch(createNewScopedFindingFailure(errorMsg));
      });
  };
};

const fetchHMISuccess = (data) => {
  return { type: FETCH_HMI_SUCCESS, payload: data };
};

const fetchHMIFailure = (error) => {
  return { type: FETCH_HMI_FAILURE, payload: error };
};

export const fetchHMI = (queryParams) => {
  return async (dispatch) => {
    return axios
      .get(machineHMIAPI, {
        params: { ...params, ...queryParams, userid: sessionStorage.getItem('userId') },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchHMISuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchHMIFailure(errorMsg));
      });
  };
};

const fetchNodeSuccess = (data) => {
  return { type: FETCH_NODE_SUCCESS, payload: data };
};

const fetchNodeFailure = (error) => {
  return { type: FETCH_NODE_FAILURE, payload: error };
};

export const fetchNode = (queryParams) => {
  return async (dispatch) => {
    return axios
      .get(machineNodeAPI, {
        params: { ...params, ...queryParams, userid: sessionStorage.getItem('userId') },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchNodeSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchNodeFailure(errorMsg));
      });
  };
};

const fetchFunctionSuccess = (data) => {
  return { type: FETCH_FUNCTION_SUCCESS, payload: data };
};

const fetchFunctionFailure = (error) => {
  return { type: FETCH_FUNCTION_FAILURE, payload: error };
};

export const fetchFunction = (queryParams) => {
  return async (dispatch) => {
    return axios
      .get(machineFunctionAPI, {
        params: { ...params, ...queryParams, userid: sessionStorage.getItem('userId') },
        headers: header,
      })
      .then((response) => {
        dispatch(fetchFunctionSuccess(response.data));
      })
      .catch((error) => {
        const errorMsg = error.response.data.message;
        dispatch(fetchFunctionFailure(errorMsg));
      });
  };
};

export const setComponentLoading = (status) => {
  return { type: SET_LOADING, payload: status };
};
